import React from 'react';
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { browserHistory } from "react-router";
import { Page, PageHeader, PageBody } from "../base/Page";
import API from "../base/API";
import Auth from "../auth/Auth";
import SorTable from "../base/SorTable";
import { translate } from "../base/Translation";

export default class WeaveGroupEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_weave_group: "/weave_group/fetch/:id",
			save_weave_group: "/weave_group/save/:id",
			get_weaves: "/weave/fetch/all"
		});

		this.weave_group = false;

		this.state = {
			weaves: [],
			tableData: [],
			tableColumns: [
				{ name: "selected", display: "#", sort: true, width: 5 },
				{ name: "name", display: translate("Názov"), sort: true, width: 95 },
			]
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData() {

		this.api.request({
			route: "get_weave_group",
			params: { id: this.props.params.weaveGroupID },
			success: function (response) {
				this.weave_group = response;
				this.api.request({
					route: "get_weaves",
					success: function (response) {
						let tableData = this.convertDataForTable(response);
						this.setState({ weaves: response, tableData });
					}.bind(this)
				});
			}.bind(this)
		});


	}

	convertDataForTable(data) {
		return data.map(function (weave) {
			let data = {};
			data.name = weave.name;

			let selected = this.weave_group.weaves.findIndex(function (w) {
				return w.id === this;
			}.bind(weave.id));

			data.selected = (
				<div>
					<input type="checkbox"
						defaultValue={weave.id}
						checked={selected > -1 ? true : false}
						onChange={this.onWeaveSelected.bind(this)} />
				</div>
			);
			return data;
			// eslint-disable-next-line
		}.bind(this));
	}

    /*
     *
     * Events
     *
     */

	onWeaveSelected(evt) {

		let selectedWeaveIndex = this.weave_group.weaves.findIndex(function (u, index) {
			return parseInt(u.id, 10) === parseInt(this, 10);
		}.bind(evt.target.value));

		// If exists remove else add
		if (selectedWeaveIndex > -1) {
			this.weave_group.weaves.splice(selectedWeaveIndex, 1);
		} else {
			this.weave_group.weaves.push({ id: parseInt(evt.target.value, 10) })
		}

		// convertData... needs to have up to date state of state.client
		// There is other better ways, for now this will be good
		let tableData = this.convertDataForTable(this.state.weaves);
		this.setState({ tableData });
	}

	onWeaveGroupSave() {


		this.api.request({
			route: "save_weave_group",
			params: { id: this.props.params.weaveGroupID },
			data: this.weave_group,
			created: (response) => {
				browserHistory.push("/weave_groups");
			}
		});
	}

	onWeaveGroupChange(evt) {
		this.weave_group[evt.target.name] = evt.target.value;
	}

	render() {

		if (!this.weave_group || !this.state.weaves) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (

			<Page>
				<PageHeader title={translate("Upraviť skupinu vĺn")} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné informácie")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl
										name="name"
										defaultValue={this.weave_group.name}
										onChange={this.onWeaveGroupChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Vlny")}>
								<SorTable
									columns={this.state.tableColumns}
									data={this.state.tableData}
									headers={true}
									searchWidth="100%"
									searchBy="name" />
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button
									bsStyle="success"
									onClick={this.onWeaveGroupSave.bind(this)}
									>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		)
	}
}


// WEBPACK FOOTER //
// ./src/modules/weave_group/WeaveGroupEdit.js